import { LoadingScreenProps } from '../../types'

interface TransformedProps {
  title: string
  description: string
  timer: {
    enabled: boolean
    durationInSeconds: number
  }
  refresh: {
    enabled: boolean
    refreshIntervalInSec: number
  }
  statusScreenProps: any
}

/**
 * Class to transform the props for LoadingScreen.
 * It normalizes the props structure, ensuring that the component
 * receives props in a consistent format.
 */
export class LoadingScreenTransformer {
  /**
   * Transforms the input props into a standardized format.
   *
   * @param props  The props to be transformed.
   * @returns An object of type TransformedProps, with a consistent structure.
   */
  static transform(props: LoadingScreenProps): TransformedProps {
    return {
      title: props.title || '',
      description: props.description || props.subTitle || '',
      timer: {
        enabled: props.timer?.enabled || false,
        durationInSeconds:
          props.timer?.durationInSec || props.timer?.durationInSeconds || 0,
      },
      refresh: {
        enabled:
          props.refresh?.enabled || props.refresh?.shouldRefresh || false,
        refreshIntervalInSec: props.refresh?.refreshIntervalInSec || 0,
      },
      statusScreenProps: props.statusScreenProps || {},
    }
  }
}
